(function() { window.GUID_30aa2eb6_c6a0_4ded_817c_e11b31d5f932 = { getGuid: function() { return "30aa2eb6-c6a0-4ded-817c-e11b31d5f932"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        var Base;
        (function (Base) {
            class RefreshOnChange extends Base.BaseControl {
                constructor() {
                    super();
                }
                ExtractElementIdsFromData(dataContainer) {
                    var bind = dataContainer.data('bindelementids');
                    if (bind != null) {
                        this.BindElementIds = bind.split(',');
                    }
                    var refresh = dataContainer.data('refreshelementids');
                    if (refresh != null) {
                        this.RefreshElementIds = refresh.split(',');
                    }
                }
                RefreshOnElementValueChange(callback) {
                    //Ici, je m'abonne à l'event Change des controles passé dans RefreshElementIds
                    var me = this;
                    if (me.RefreshElementIds != undefined) {
                        var lastIndex = me.RefreshElementIds.length - 1;
                        if (me.RefreshElementIds != null && me.RefreshElementIds[0] != "") {
                            $.each(me.RefreshElementIds, function (index, id) {
                                var control = $('#' + id);
                                if (control.length == 0) {
                                    control = $('[name="' + id + '"]');
                                }
                                var eventWithNamespace = 'change.' + me.Id;
                                control.off(eventWithNamespace);
                                control.on(eventWithNamespace, function () {
                                    callback.call(this);
                                });
                            });
                        }
                    }
                }
            }
            Base.RefreshOnChange = RefreshOnChange;
        })(Base = Controls.Base || (Controls.Base = {}));
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=RefreshOnChange.js.map
